export class GWAttribute {
    public name: string;
    public value: any;

    constructor(name?: string, value?: any) {
        this.name = name ? name : null;
        this.value = value !== null && value !== undefined ? value : null;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-attribute.model.ts